import model from 'modules/bot/botModel';

const { fields } = model;

export default [
  fields.type,
  fields.content,
  fields.subType,
  fields.subject,
  fields.trigger,
  fields.company,
  fields.enable,
];
